import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {MultipageTemplateData, TemplatesFiltersData} from '@Libraries/editor-templates-library';

export enum TemplatesViewType {
  TEMPLATES_GRID = 'templates-grid',
  MULTIPAGE_DETAILS = 'multipage-details',
}

interface State {
  filters: TemplatesFiltersData;
  currentView: TemplatesViewType;
  selectedTemplate: MultipageTemplateData | null;
}

const initialState: State = {
  filters: {},
  currentView: TemplatesViewType.TEMPLATES_GRID,
  selectedTemplate: null,
};

export const templatesPopupSlice = createSlice({
  name: 'templatesPopup',
  initialState,
  reducers: {
    setFiltersData: (state, action: PayloadAction<TemplatesFiltersData>) => {
      state.filters = action.payload;
    },
    setTemplatesView: (state, action: PayloadAction<TemplatesViewType>) => {
      state.currentView = action.payload;
    },
    setSelectedTemplate: (state, action: PayloadAction<MultipageTemplateData | null>) => {
      state.selectedTemplate = action.payload;
    },
    resetTemplatesPopupState: (state) => {
      state.currentView = TemplatesViewType.TEMPLATES_GRID;
      state.selectedTemplate = null;
    },
  },
});

export const {setFiltersData, setTemplatesView, setSelectedTemplate, resetTemplatesPopupState} = templatesPopupSlice.actions;
export const templatesPopupReducer = templatesPopupSlice.reducer;

